/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Permissions_Noinvestments2Inputs */

const en_usermanagement_permissions_noinvestments2 = /** @type {(inputs: Usermanagement_Permissions_Noinvestments2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You currently do not have the permission to invite new users to any of your available funds`)
};

/**
* | output |
* | --- |
* | "You currently do not have the permission to invite new users to any of your available funds" |
*
* @param {Usermanagement_Permissions_Noinvestments2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_permissions_noinvestments2 = /** @type {((inputs?: Usermanagement_Permissions_Noinvestments2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Permissions_Noinvestments2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_permissions_noinvestments2(inputs)
});
export { usermanagement_permissions_noinvestments2 as "userManagement_permissions_noInvestments" }